var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FullMasterTemplate',{attrs:{"useLeft":false},scopedSlots:_vm._u([{key:"gnb",fn:function(){return [_c('GnbLeftView')]},proxy:true}])},[_c('div',{staticClass:"full-content",attrs:{"id":"inner-wrap"}},[_c('DesignPersonal',{attrs:{"company":'HK',"personal":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }